var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[(!_vm.organisation.isLoading)?_c('apexchart',{attrs:{"type":"bar","options":_vm.options,"series":_vm.series}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }